import { includesPermission } from '../../utils/utils';
import { resolveDefaultResourceScope, resolveRbacPermission } from './permissionMapping';
import useLegacyTokenPermission from './useLegacyTokenPermission';
import usePermissionsMode from './usePermissionsMode';
import useResourcePermissions from './useResourcePermissions';

// REMOVE(settings-users-and-access): Collapse to RBAC-only permission checks when flag is retired.
export function usePermissionCheck({
  permission,
  rbacPermission,
  resourceType,
  resourceId,
  defaultValue = false,
  loadingValue = false
}) {
  const { isRbacEnabled } = usePermissionsMode();
  const legacyAllowed = useLegacyTokenPermission({
    permission,
    defaultValue,
    skip: isRbacEnabled
  });

  const rbacPerm = rbacPermission ?? resolveRbacPermission(permission);
  const scope = resourceType ?? resolveDefaultResourceScope(permission).resourceType;
  const { permissions, loading } = useResourcePermissions({
    resourceType: scope,
    resourceId,
    skip: !isRbacEnabled
  });

  if (!isRbacEnabled) {
    return { allowed: legacyAllowed, loading: false };
  }

  if (loading) {
    return { allowed: loadingValue, loading: true };
  }

  if (!rbacPerm) {
    return { allowed: false, loading: false };
  }

  return {
    allowed: includesPermission(permissions, rbacPerm),
    loading: false
  };
}

function useHasPermission({
  permission,
  rbacPermission,
  resourceType,
  resourceId,
  defaultValue = false,
  loadingValue = false
}) {
  return usePermissionCheck({
    permission,
    rbacPermission,
    resourceType,
    resourceId,
    defaultValue,
    loadingValue
  }).allowed;
}

export default useHasPermission;
